module.exports = __webpack_public_path__ + "static/media/J (7).76d7201a.jpg";